
const platform_value = 'web';
const web ='web';
const SESSION_ID_KEY = 'mb-s-sessionId';
const USER_DETAILS_KEY = 'user_details';

export const getUserDetails = () => {
    let userDetails = (localStorage.getItem(USER_DETAILS_KEY));
    userDetails = typeof userDetails != 'string' ? userDetails : JSON.parse(userDetails);
    return userDetails
  }
  
const getMBSessionId = () => {
  return localStorage.getItem(SESSION_ID_KEY);
}

export class MBAnalytics {
     is_snowplow_enabled;
     event_payload_snowplow = {};
     sendToSnowplow(schema, params) {}
     trackUserOnLogin(userDetails) {}
    constructor(analytics_platforms) {
      this.is_snowplow_enabled = analytics_platforms.includes("snowplow");
      this.initEventPayload();
    }

  sendToSnowplow = (schema, params) => {
    if (!this.is_snowplow_enabled) throw new Error("snowplow is not enabled");
    const payload = { ...params };
    const fullPayload = { ...this.event_payload_snowplow, ...payload };

    if(window?.snowplow) {
      window.snowplow("trackSelfDescribingEvent", {
        event: {
          schema,
          data: fullPayload,
        },
      });
      return;
    }

    // Retry until snowplow is loaded into window
    const sendSnowplowEvent = () => {
      const checkSnowplow = setInterval(() => {
        if (window.snowplow) {
          window.snowplow("trackSelfDescribingEvent", {
            event: {
              schema,
              data: fullPayload,
            },
          });
          clearInterval(checkSnowplow);
        }
      }, 100);
    };

    sendSnowplowEvent();

  };


  initEventPayload = () => {
    try {
      if (this.is_snowplow_enabled) {
        this.event_payload_snowplow.appversion = "v1.0";
        this.event_payload_snowplow.platform = "web";
        this.event_payload_snowplow[SESSION_ID_KEY] = '' + this.generateSessionId();
      }
    } catch (ex) {
      console.log("Error in initEventPayload", ex);
    }
  };

  trackUserOnLogin = async (userDetails) => {
    try {
      if (!Object.keys(userDetails).length) {
        throw new Error("user details are required to track user on login");
      }
      
      let platform = platform_value
        platform = platform_value 
      if (this.is_snowplow_enabled) {
        this.event_payload_snowplow.platform = platform;
        this.event_payload_snowplow.provider_name= userDetails.entityName;
        this.event_payload_snowplow.provider_id = '' + (userDetails.providerId ||  userDetails.parentId);
        this.event_payload_snowplow.appversion = 'v1.0'
        this.event_payload_snowplow.username = userDetails.userName;
      }
      console.log('setUerId ', this.event_payload_snowplow);
      window.snowplow("setUserId", userDetails?.userName);
    } catch (ex) {
      console.log("Error in trackUserOnLogin", ex);
    }
  };

  generateSessionId = () => {
    let mb_s_session_id = getMBSessionId();
    if (mb_s_session_id) {
      return mb_s_session_id;
    }
    const result = [];
    const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const suffixLen = 4;
    for (let i = 0; i < suffixLen; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      result.push(charset.charAt(randomIndex));
    }
    mb_s_session_id = `${Date.now()}__${web}__${result.join("")}`;
    localStorage.setItem(SESSION_ID_KEY, mb_s_session_id);
    return mb_s_session_id;
  };

}
